<box class="card-actions">
    <ng-container *ngIf="isRegisterVal">
        <fpx-button class="tpay-btreg" btnType="button" (onClick)="nfcDefaultAppCheck1()" label="REGISTER FOR TAP TO PAY" ></fpx-button>
    </ng-container>
</box>
<box class="card-actions">
    <ng-container *ngIf="isCardStatusActVal_Default">
        <p class="nfccard_info">Virtual account number 
            <button id="infoTab" value="infoTab" (click)="enableTooltip();" type="button"><img src="./assets/images/tooltip_icon.svg" /></button>
            <span class="tooltiptext_img" *ngIf="displayTooltip">When you pay contactless,<br> this number is used instead of your card <br>number to protect your information.
            </span>
            <span>Visa<span class="nfcCardMask">....</span>{{digitalCardNum}}</span>
        </p>
        <div class="contctLessbtn">
            <img src="./assets/images/nfc/tap_default.png">
            <span>Default for contactless</span>
        </div>
    </ng-container>
 </box>
<box>
    <box class="container-title">
        <h2>Card Control</h2>
    </box>

    <!-- <box class="tab-bar">
        <app-h-tab-bar #tabBar 
            [tabs]="tabList"
            type="debit-card"
            (onSelectTab)="onSelectTab($event)"></app-h-tab-bar>
    </box> -->

    <box class="linked-account-info-container">
        <app-dc-service-request-form [containerData]="containerData"></app-dc-service-request-form>
        <!-- <app-dc-linked-account-info-form [accountInfo]="accountInfo"></app-dc-linked-account-info-form> -->
    </box>

    <!-- <box class="tab-content">
        <ng-container *ngIf="tabBar.activeTab == 'history'">
            debit card history tab
        </ng-container>
        <ng-container *ngIf="tabBar.activeTab == 'details'">
            debit card details tab
        </ng-container>
    </box> -->
</box>